import React, { Component } from 'react';
import { EditAction, ActionRejectUser } from '../Common/Buttons/Icons';

class ExpenseActionsComponent extends Component {

    render() {
        return (
            <div className = "button-group">
                <a className = "float-right mr-8" onClick={this.props.onClickEdit} style={{cursor: 'pointer'}}>
                    {EditAction()}
                </a>
                {this.props.onClickDelete ? <a className = "float-right" onClick={this.props.onClickDelete} style={{cursor: 'pointer'}}>
                    {ActionRejectUser()}
                </a> : null}
            </div>
        )
    }
}

export default ExpenseActionsComponent;